
jQuery(document).ready(function() {
  // Your code here
  console.log("ADA script is working!");

		jQuery('.social-media__facebook').attr("aria-label","facebook page, open in new tab");
		jQuery('.social-media__twitter').attr("aria-label","twitter page, open in new tab");
		jQuery('.social-media__instagram').attr("aria-label","Instagram page, open in new tab");
		jQuery('.social-media__pinterest').attr("aria-label","pinterest page, open in new tab");
		jQuery('.header__btn-account').attr("aria-label","My account page, opens in left slider");
    	jQuery('.product-collection__variants select').attr("aria-hidden","true");
    	jQuery('.product-page-info select').attr("aria-hidden","true");
    	jQuery('.product-page-info select').attr("aria-label","colour and size");
    	jQuery('.prorw_rating__input.prorw_rating__input--none').attr("aria-label","Product Rating");
    	jQuery('.Banner1 a').attr("aria-label","Shop Now, womens sandals");
    	jQuery('.Banner2 a').attr("aria-label","Let's shop, the siena sport sandals for women");
    	jQuery('.Banner3 a').attr("aria-label","Let's shop, acadia hiking sandal for women");
    	jQuery('.Banner4 a').attr("aria-label","discover now the samara walking sandal for women");
    	jQuery('.Banner6 a').attr("aria-label","siena sport sandals for women");
    	jQuery('.Banner7 a').attr("aria-label","Shop now CORTONA sandals for women");
    	jQuery('.Banner8 a').attr("aria-label","Shop Now, Siena: Lightweight, Stylish & Durable Sport Sandals");
    	jQuery('.Banner9 a').attr("aria-label","Shop Now, Napali: Breathable Waterproof Hiking Sandals");
    	jQuery('.Banner10 a').attr("aria-label"," Shop All style");
    	jQuery('.header__btn-compare').attr("aria-label","Compare option, dialog open on same page");
    	jQuery('.header__btn-compare').attr("haspopup","true");
    	jQuery('.footer__back-to-top').attr("aria-label","back to top");
    	jQuery('#s-32a4bbb7-8d48-4b98-9e1a-2457005300e1 a').attr("aria-label","Cortona: Sporty & Stylish Active Sandals for Women");
    	jQuery('#s-295f91f8-8e11-4a47-8bdc-8fa8a558d760 a').attr("aria-label","Siena: Lightweight, Stylish & Durable Sport Sandals");
    	jQuery('#s-10297c60-3c45-46cf-b478-37eaf91858f8 a').attr("aria-label","Napali: Breathable Waterproof Hiking Sandals");
    	jQuery('#shopify-section-template--19258326417657__main strong').attr("role","heading");
    	jQuery('#shopify-section-template--19258326417657__main strong').attr("aria-level","2");
    	jQuery('.jdgm-prev-badge__stars').removeAttr("tabindex");
    	jQuery('.jdgm-prev-badge__stars').removeAttr("role");
    	jQuery('.jdgm-prev-badge__stars').removeAttr("aria-label");
    	jQuery('.price.price--sale span').attr("aria-hidden","true");
    	
 
	jQuery('.header__tape-close').attr('aria-label', "close");
	jQuery('.header__tape-close, .header__btn-menu, .popup-navigation__close').attr('role', "button");
	jQuery('.header__tape-close').attr('tabindex', "0");
	jQuery('.header__btn-menu').attr('aria-label', "Open Menu");
	jQuery('.popup-navigation__close').attr('aria-label', "Close Menu");
  	jQuery('.popup-navigation__close').attr('tabindex', "0");

 
document.querySelectorAll('.header__tape-close').forEach((closeBtn) => {
  // Click already works
  closeBtn.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault(); // prevent page scroll if Space is pressed
      closeBtn.click(); // simulate the click

    }
  });
});

  
	jQuery('input[name="NAME"]').attr('aria-label', "Name");
	jQuery('input[name="EMAIL"]').attr('aria-label', "Email");
	jQuery('textarea[name="MESSAGE"]').attr('aria-label', "MESSAGE");


  
  	jQuery('input[name="customer[first_name]"]')
  .attr('aria-label', 'First name')
  .attr('autocomplete', 'given-name');

jQuery('input[name="customer[last_name]"]')
  .attr('aria-label', 'Last name')
  .attr('autocomplete', 'family-name');

jQuery('input[name="customer[email]"]')
  .attr('aria-label', 'Email address')
  .attr('autocomplete', 'email');

jQuery('input[name="customer[password]"]')
  .attr('aria-label', 'Password')
  .attr('autocomplete', 'new-password'); // Better than 'off' for new accounts


jQuery('input[name="contact[product_url]"]').attr('aria-label', 'Product url');
jQuery('input[name="contact[product_sku]"]').attr('aria-label', 'Product sku');
jQuery('input[name="contact[name]"]').attr('aria-label', 'name');
jQuery('input[name="contact[email]"]').attr('aria-label', 'email');
jQuery('input[name="contact[phone]"]').attr('aria-label', 'phone');
jQuery('textarea[name="contact[body]"]').attr('aria-label', 'message area');
jQuery('input[name="quantity"]').attr('aria-label', 'quantity');
jQuery('label[id="prorw_pictures_label"]').attr('aria-label', 'pictures label');

jQuery('.stock-countdown__title, .shogun-accordion-title, .shogun-heading-component h1, .footer__section-head h5, .footbar-product__title h4').attr("role","heading");
jQuery('.stock-countdown__title, .shogun-accordion-title, .shogun-heading-component h1, .footer__section-head h5, .footbar-product__title h4').attr("aria-level","2");
jQuery('.product-collection__title h4').attr("role","heading");
jQuery('.product-collection__title h4').attr("aria-level","3");
  
jQuery('.footbar-product.w-100.js-footbar-product').attr("role","complementary");
jQuery('.footer__back-to-top').attr("role","navigation");
jQuery('.footer__back-to-top').attr("role","navigation");
jQuery('.js-product-button-remove-from-cart').attr("aria-label","remove item");
jQuery('.js-input-quantity-cart').attr("aria-label","product quantity");

  
jQuery('.logo.h6.w-100.m-0.text-hide').contents().filter(function() {
  return this.nodeType === 3; // Text node
}).remove();
 
jQuery('.promobox--type-1-4, .promobox--clean, .promobox--type-2, .promobox--type-1, .product-collection__image, .Banner1').each(function() {
  jQuery(this).find('a').first().attr('tabindex', '-1');
});

jQuery('.carousel__title a:first').attr("tabindex","-1");
jQuery('.product-collection__image a:first').attr("tabindex","-1");


 
});


setTimeout(function() {
  jQuery('.product-collection__variants select').attr("aria-label", "colour and size");
  jQuery('.absolute-stretch.cursor-default').attr("tabindex", "-1");
  jQuery('.absolute-stretch.cursor-default').attr("aria-hidden", "true");
  jQuery('.shg-row img').attr("alt", "");
jQuery('.product-image__overlay-bottom a').attr("tabindex", "-1");
jQuery('.product-collection__image a:first').attr("tabindex","-1");
jQuery('#s-b4671028-f24a-4e92-9002-dbecdf8ef99e img').attr("alt","We proudly donate a portion of our profits to: One Tree Planted and Soles 4 Souls Wearing out poverty");
jQuery('#s-65d7f0a6-d6be-421c-9b7e-d7ce1a21015d img').attr("alt","Sizing guide for the Acadia Sandal. The text reads: SIZING TIPS. It's easy to find the right Acadia Sandal size for you. The Acadias fit true to size, so we recommend ordering your regular size. Based on thousands of pairs sold worldwide, order your regular size. If between sizes, order one size down.A table lists corresponding sizes: If you typically wear US sizes 6 or 6.5, order Sandal Size 6. For 7 or 7.5, order Size 7. For 8 or 8.5, order Size 8. For 9 or 9.5, order Size 9.For 10 or 10.5, order Size 10. For 11 or 11.5, order Size 11. The sandals fit the following foot widths: Narrow (AA), Medium (B/M), Wide (C/D), and Extra-Wide. Additional text advises: 'If unsure about sizing, contact our customer care team for assistance. Free and easy returns are available if the sandals don’t fit.'");
jQuery('#s-0cbbd875-0b17-4b51-8bfd-ba109cd68404 img').attr("alt","Viakix Sandals sizing guide with recommendations for selecting the correct size. The text states: 'SIZING TIPS. It’s easy to find the right Viakix Sandal size. All Viakix sandals fit true to size, so we recommend ordering your regular size. Based on global sales data, choose your regular size. If you are between sizes, order one size down. A sizing chart compares typical US shoe sizes to Viakix Sandal sizes:US Sizes 6 or 6.5 → Order Sandal Size 6, US Sizes 7 or 7.5 → Order Sandal Size 7, US Sizes 8 or 8.5 → Order Sandal Size 8, US Sizes 9 or 9.5 → Order Sandal Size 9, US Sizes 10 or 10.5 → Order Sandal Size 10, US Sizes 11 or 11.5 → Order Sandal Size 11. The sandals accommodate these foot widths: Narrow (AA), Medium (B/M), Wide (C/D), and Extra-Wide (E).Additional text encourages customers to contact the support team for sizing help and notes that returns are free and easy if the sandals don’t fit.");

jQuery('#s-d1f29255-93a6-4c13-860c-ca032a2be954 a:first').attr("tabindex", "-1");
jQuery('#s-d1f29255-93a6-4c13-860c-ca032a2be954 a:first').attr("aria-label", "womens sandals");
jQuery('#s-d1f29255-93a6-4c13-860c-ca032a2be954 a:eq(1)').attr("aria-label", "Shop Now, womens sandals");
jQuery('#s-66b920ca-f084-48c1-92f1-a956d4a88505 a:first').attr("aria-label", "womens sandals");

jQuery('.social-share__item--facebook').attr("aria-label", "Share this blog to Facebook page, opens in new tab ");
jQuery('.social-share__item--twitter').attr("aria-label", "Share this blog to twitter page, opens in new tab ");
jQuery('.social-share__item--pinterest').attr("aria-label", "Share this blog to pinterest page, opens in new tab ");
jQuery('.social-share__item--linkedin').attr("aria-label", "Share this blog to linkedin page, opens in new tab ");
jQuery('.social-share__item--buffer').attr("aria-label", "Share this blog to buffer page, opens in new tab ");
jQuery('.social-share__item--reddit').attr("aria-label", "Share this blog to reddit page, opens in new tab ");

  
jQuery('.collection-filters__checkbox.input-checkbox.d-flex.align-items-center.mb-15.mb-lg-10.mr-15.mr-lg-10.input-checkbox--unbordered.cursor-pointer').attr("aria-label", "filter");
jQuery('a[href="https://www.viakix.com/products/the-napali-hiking-sandals-for-women"]').attr('aria-label', "The napili hiking sandals for women");
jQuery('a[href="https://www.viakix.com/products/the-siena-sport-sandals-for-women"]').attr('aria-label', "the siena sport sandals for women");
jQuery('a[href="https://www.viakix.com/products/siena-sport-sandals-for-women"]').attr('aria-label', "siena sport sandals for women");


 
  
}, 3000);


 
  jQuery(document).ready(function() {
    // Find all empty h2 elements and remove them
    jQuery('h3').each(function() {
      if (!jQuery(this).text().trim()) {
        jQuery(this).remove();
      }
    });
  });


jQuery('.d-none.d-lg-block.mb-10').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('/products/')) {
    // Extract the product slug from the URL
    var productSlug = href.split('/products/')[1];

    // Clean the slug: remove filler words like 'the', 'a', 'an'
    var cleaned = productSlug
      .replace(/-/g, ' ')                        // replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
      .replace(/\s+/g, ' ')                      // collapse multiple spaces
      .trim();

    // Capitalize the first letter of each word
    var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });

    // Add aria-label to the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});

jQuery('.d-none.d-lg-block.mb-10').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('https://www.viakix.com/products/')) {
    // Extract product slug from the full URL
    var productSlug = href.split('https://www.viakix.com/products/')[1];

    // Clean and format it for ARIA label
    var ariaLabel = productSlug
      .replace(/-/g, ' ')                      // Replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')         // Remove filler words
      .replace(/\s+/g, ' ')                    // Remove extra spaces
      .trim()                                  // Trim start/end
      .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word

    // Set the aria-label on the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});

jQuery('.d-none.d-lg-block.mb-10').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('https://www.viakix.com/collections/')) {
    // Extract product slug from the full URL
    var productSlug = href.split('https://www.viakix.com/collections/')[1];

    // Clean and format it for ARIA label
    var ariaLabel = productSlug
      .replace(/-/g, ' ')                      // Replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')         // Remove filler words
      .replace(/\s+/g, ' ')                    // Remove extra spaces
      .trim()                                  // Trim start/end
      .replace(/\b\w/g, c => c.toUpperCase()); // Capitalize each word

    // Set the aria-label on the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});


jQuery('.d-block').each(function () {
  var href = jQuery(this).attr('href');

  if (href && href.includes('/products/')) {
    // Extract the product slug from the URL
    var productSlug = href.split('/products/')[1];

    // Clean the slug: remove filler words like 'the', 'a', 'an'
    var cleaned = productSlug
      .replace(/-/g, ' ')                        // replace hyphens with spaces
      .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
      .replace(/\s+/g, ' ')                      // collapse multiple spaces
      .trim();

    // Capitalize the first letter of each word
    var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });

    // Add aria-label to the <a> tag
    jQuery(this).attr('aria-label', ariaLabel);
  }
});



document.querySelectorAll('.product-collection__wrapper').forEach(wrapper => {
  const title = wrapper.querySelector('.product-collection__title')?.textContent.trim();
  
  if (title) {
    wrapper.querySelectorAll('.d-block').forEach(block => {
      block.setAttribute('aria-label', title);
    });
  }
});


setTimeout(function () {
  jQuery('.absolute-stretch.cursor-default').each(function () {
    var href = jQuery(this).attr('href');

    if (href && href.includes('/products/')) {
      // Extract the product slug from the URL
      var productSlug = href.split('/products/')[1];

      // Clean the slug: remove filler words like 'the', 'a', 'an'
      var cleaned = productSlug
        .replace(/-/g, ' ')                        // replace hyphens with spaces
        .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
        .replace(/\s+/g, ' ')                      // collapse multiple spaces
        .trim();

      // Capitalize the first letter of each word
      var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });

      // Add aria-label to the <a> tag
      jQuery(this).attr('aria-label', ariaLabel);
    }
  });
}, 3000); // 3000 milliseconds = 3 seconds


setTimeout(function () {
  jQuery('.absolute-stretch.cursor-default').each(function () {
    var href = jQuery(this).attr('href');

    if (href && href.includes('/collections/womens-sandals/products/')) {
      // Extract the product slug from the URL
      var productSlug = href.split('/collections/womens-sandals/products/')[1];

      // Clean the slug: remove filler words like 'the', 'a', 'an'
      var cleaned = productSlug
        .replace(/-/g, ' ')                        // replace hyphens with spaces
        .replace(/\b(the|a|an)\b/gi, '')           // remove filler words
        .replace(/\s+/g, ' ')                      // collapse multiple spaces
        .trim();

      // Capitalize the first letter of each word
      var ariaLabel = cleaned.replace(/\b\w/g, function (char) {
        return char.toUpperCase();
      });

      // Add aria-label to the <a> tag
      jQuery(this).attr('aria-label', ariaLabel);
    }
  });
}, 3000); // 3000 milliseconds = 3 seconds


//=========================

function forceTabindexNegativeOne() {
  const links = document.querySelectorAll('.absolute-stretch.cursor-default[tabindex="0"]');
  links.forEach((link) => link.setAttribute('tabindex', '-1'));
}

// Check every 500ms (adjust as needed)
setInterval(forceTabindexNegativeOne, 500);

//========================

$('#shopify-section-template--19258325303545__main a').each(function () {
    var href = $(this).attr('href');
    
    // Make sure it's a blog URL
    if (href && href.includes('/blogs/news/')) {
        // Extract the blog title from URL
        var slug = href.split('/').pop(); // Gets the last part of the URL
        var title = decodeURIComponent(slug.replace(/-/g, ' '));
        
        // Capitalize first letter
        title = title.charAt(0).toUpperCase() + title.slice(1);

        // Set aria-label
        $(this).attr('aria-label', 'Learn more about ' + title);
    }
});

//========================

$(document).ready(function () {
  $('.price--sale').each(function () {
    const $priceWrapper = $(this);
    const $originalPrice = $priceWrapper.find('span').eq(0);
    const $salePrice = $priceWrapper.find('span').eq(1);

    const originalPriceText = $originalPrice.text().trim();
    const salePriceText = $salePrice.text().trim();

    // Build and set the aria-label
    const ariaLabel = `Original price ${originalPriceText}, now ${salePriceText}`;
    $priceWrapper.attr('aria-label', ariaLabel);
  });
});


//=======Sortsite errors=================

jQuery('.footer__section-head').attr('role', 'button');
jQuery('.footer__back-to-top').attr('aria-label', 'back to top');

